<script lang="ts">
  import { onMount, onDestroy } from "svelte";
  import ContentEditableText from "./ContentEditableText";
  export let text: string;
  export let setSavedState: (isSaved: boolean) => void;
  export let saveText: (text: string) => Promise<void>;
  export let allowSave: (() => boolean) | undefined;
  let instance: ContentEditableText;
  function init(node: HTMLElement) {
    instance = new ContentEditableText(node, text, undefined, () => {
      setSavedState(false);
    });
  }

  function save() {
    saveText(instance.getText())
      .then(() => {
        setSavedState(true);
      })
      .catch(() => {
        return;
      });
  }

  function onKeyDown(e: KeyboardEvent) {
    if (e.ctrlKey && e.key === "s") {
      e.preventDefault();
      e.stopPropagation();
      if (undefined === allowSave || allowSave()) {
        save();
      }
    }
  }

  onMount(() => {
    document.addEventListener("keydown", onKeyDown);

    return () => {
      document.removeEventListener("keydown", onKeyDown);
    };
  });

  onDestroy(() => {
    instance.destroy();
  });
</script>

<div class="NotesEditor">
  <div
    class="ContentEditable"
    contenteditable={true}
    spellcheck={false}
    use:init
  />
</div>

<style type="text/scss">
  .NotesEditor {
    padding: 20px;
  }
  .ContentEditable {
    font-family: "sans_regular", sans-serif;
    box-sizing: border-box;
    font-size: 16px;
    outline: none;
    border: none;
    padding: 5px;
    border-radius: 0;
    background: #fff;
    line-height: 22px;
    :global(.TextBlock) {
      min-height: 22px;
      box-sizing: content-box;
    }

    :global(.TextBlock--header-1) {
      color: #9c1171;
    }

    :global(.TextBlock--header-2) {
      color: #9c1171;
    }

    :global(.TextBlock--header-3) {
      color: #9c1171;
    }

    :global(.TextBlock--header-4) {
      color: #9c1171;
    }

    :global(.TextBlock--header-5) {
      color: #9c1171;
    }

    :global(.TextBlock--header-6) {
      color: #9c1171;
    }

    :global(.TextBlock--bullet-1),
    :global(.TextBlock--done-bullet-1) {
      padding-left: 10px;
    }

    :global(.TextBlock--bullet-2),
    :global(.TextBlock--done-bullet-2) {
      padding-left: 20px;
    }

    :global(.TextBlock--bullet-3),
    :global(.TextBlock--done-bullet-3) {
      padding-left: 30px;
    }

    :global(.TextBlock--done-bullet-1),
    :global(.TextBlock--done-bullet-2),
    :global(.TextBlock--done-bullet-3) {
      text-decoration: line-through;
    }

    :global(.emphasis--bold) {
      font-weight: bold;
    }
    :global(.emphasis--italics) {
      font-style: italic;
    }
    :global(.emphasis--underline) {
      text-decoration: underline;
    }
    :global(.em-char) {
      color: rgb(187, 187, 187);
    }
    :global(.note) {
      color: #57d0d6;
    }
    :global(.TextBlock--image span) {
      color: rgb(187, 187, 187);
    }
    :global(.TextBlock--image span.path) {
      color: rgb(149, 149, 149);
    }
    :global(.TextBlock--image span.path-indicator) {
      color: #d71da0;
    }
    :global(.TextBlock--excluded) {
      display: block;
      pointer-events: none;
      cursor: none;
      user-select: none;
    }
    :global(.TextBlock--image img) {
      max-width: 100%;
      margin-bottom: 5px;
    }
  }
</style>
